import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select"]
  static values = {
    frameId: String
  }

  connect() {
    console.log("Plan select controller connected - debug version")
    
    // Debug to verify we're connecting
    const debugElement = document.createElement('div')
    debugElement.textContent = 'Controller connected'
    debugElement.style.display = 'none'
    document.body.appendChild(debugElement)
  }
  
  change(event) {
    console.log("Change event triggered with value:", event.target.value)
    
    const planId = event.target.value
    
    if (planId) {
      const frame = document.getElementById(this.frameIdValue)
      console.log("Looking for frame with ID:", this.frameIdValue)
      
      if (frame) {
        console.log("Frame found, navigating...")
        
        // Construct the URL for the admin prices path
        const baseUrl = window.location.pathname.split('/').slice(0, 3).join('/')
        const url = `${baseUrl}/${planId}/prices`
        
        console.log("Navigating to URL:", url)
        
        // Navigate the frame to the new URL
        frame.src = url
        // Needed for frame navigation
        frame.reload()
      } else {
        console.error("Frame not found with ID:", this.frameIdValue)
      }
    }
  }
}